<template>
  <section class="filters">
    <Filter/>
  </section>
  <section class="posts">
    <ItemList/>
    <button class="show-more" v-if="itemStore.hasMore" @click="itemStore.showMore()"></button>
  </section>
</template>

<script lang="ts" setup>
import {useItemStore} from "@/stores/items";
import ItemList from "@/components/ItemList.vue";
import Filter from "@/components/Filter.vue";

const itemStore = useItemStore();
</script>

<style lang="scss">
.dynamic-archive {

}
</style>
